module.exports = __webpack_public_path__ + "static/media/seaFreight.071eae3d.jpg";